/**
 * Remember Me utility - stores ONLY username/email in localStorage
 * Tokens and user data stored in localStorage (cleared on browser close)
 */

const REMEMBER_ME_KEY = 'remembered_username';

export const rememberMeUtils = {
  /**
   * Save username to localStorage (persists across browser sessions)
   */
  saveUsername(username: string): void {
    localStorage.setItem(REMEMBER_ME_KEY, username);
  },

  /**
   * Get saved username from localStorage
   */
  getSavedUsername(): string | null {
    return localStorage.getItem(REMEMBER_ME_KEY);
  },

  /**
   * Clear saved username from localStorage
   */
  clearSavedUsername(): void {
    localStorage.removeItem(REMEMBER_ME_KEY);
  },

  /**
   * Check if a username is saved
   */
  hasRememberedUsername(): boolean {
    return !!localStorage.getItem(REMEMBER_ME_KEY);
  },
};

export default rememberMeUtils;
